import Vue from 'vue';

export default {

  data() {
    return {
      loading: false,
      users: [],
      error: null,
      success: false
    };
  },
  watch: {
    users: {
      handler: function (val, oldVal) {
        /* ... */
        this.users = val;
      },
      deep: true
    }
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue')
  },
  methods: {
    get_sub_users(){
      //TODO Use Service for getting sub users
      Vue.$http.get('/sub-users').then((response) => {
        this.users = response.data.user;
        this.loading = false;
      }).catch((error) => {
        if (error.response) {
          this.loading = false;
        }
      });
    },
    delete_users (id) {
      let vm = this;
      swal({
            title: "Are you sure?",
            text: "You will not be able to recover this sub user!",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-warning",
            confirmButtonText: 'Yes, delete it!',
            closeOnConfirm: false,
          },
          function() {
            //TODO Use service for deleting sub users
            Vue.$http.delete('/sub-users/' + id).then((response) => {
              if (response && response.status === 200) {
                vm.get_sub_users();
                swal("Deleted!", "Your imaginary sub user has been deleted!", "success");
              }
            }).catch((error) => {
              if (error.response) {
                swal("Error!", error.response.data.msg, "warning");
                //this.error = error.response.data.msg;
                toastr.error(error.response.data.msg);
              }
            });

          });
    },
    new_user (){
      Vue.router.push({
        name: 'users.create',
      });
    },
    edit (id){
      Vue.router.push({
        name: 'users.details',
        params: { id: id }
      });
    },
  },
  mounted() {
    this.loading = true;
    this.get_sub_users();
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/users/index/index.js